import * as React from "react";
import { Breadcrumbs } from "../../Breadcrumbs";
import { Container, ContainerFW } from "../../global";
export const BreadcrumbsBanner = (props) => (React.createElement(ContainerFW, { backgroundColor: props.backgroundColor },
    React.createElement(Container, null,
        React.createElement(Breadcrumbs, { breadcrumbs: props.breadcrumbs, lightMode: props.lightmode }))));
